import React from 'react';
import PropTypes from 'prop-types';
import useCMS from '../../hooks/useCMS';
import {
  FINISH_WITH_HUMAN_CMS_KEY,
  FINISH_WITH_HUMAN_HREF_FALLBACK,
} from '../../config/constants';

const CMS_KEYS = [FINISH_WITH_HUMAN_CMS_KEY];

const FinishWithHumanPill = ({ variant, href: hrefOverride }) => {
  const { cms } = useCMS(CMS_KEYS);
  // TODO(v2-1-backend): wire to useCMS hook once CMS seed for FINISH_WITH_HUMAN_CMS_KEY exists
  const cmsValue = cms(FINISH_WITH_HUMAN_CMS_KEY);

  const href = hrefOverride || cmsValue || FINISH_WITH_HUMAN_HREF_FALLBACK;

  const className =
    variant === 'floating'
      ? 'hg-finish-human-pill hg-finish-human-pill--floating'
      : 'hg-finish-human-pill hg-finish-human-pill--inline';

  return (
    <a
      // href={href}
      // target="_blank"
      // rel="noopener noreferrer"
      className={`${className} hg-link--disabled`}
      data-testid="finish-with-human-pill"
    >
      <span aria-hidden="true">📞</span>
      <span>Finish with a human</span>
    </a>
  );
};

FinishWithHumanPill.propTypes = {
  variant: PropTypes.oneOf(['floating', 'inline']),
  href:    PropTypes.string,
};

FinishWithHumanPill.defaultProps = {
  variant: 'floating',
  href:    null,
};

export default FinishWithHumanPill;
